import React, { useState, useEffect } from 'react';
import { getActivities, addActivity } from '../utils/api';
import { ar, en } from '../utils/translations';

const ActivityModal = ({ contactType, contactId, contactName, onClose, language = 'ar' }) => {
  const t = language === 'ar' ? ar : en;
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddForm, setShowAddForm] = useState(false);
  const [formData, setFormData] = useState({
    activity_type: 'call',
    title: '',
    description: ''
  });

  useEffect(() => {
    loadActivities();
  }, [contactType, contactId]);

  const loadActivities = async () => {
    try {
      setLoading(true);
      const response = await getActivities(contactType, contactId);
      setActivities(response.data);
    } catch (error) {
      console.error('Error loading activities:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addActivity({
        contact_type: contactType,
        contact_id: contactId,
        ...formData
      });
      setFormData({ activity_type: 'call', title: '', description: '' });
      setShowAddForm(false);
      loadActivities();
    } catch (error) {
      console.error('Error adding activity:', error);
      alert(t.failedToSave);
    }
  };

  const getActivityIcon = (type) => {
    switch(type) {
      case 'call': return '📞';
      case 'whatsapp': return '💬';
      case 'email': return '✉️';
      case 'meeting': return '🤝';
      case 'note': return '📝';
      default: return '📋';
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '700px' }}>
        <div className="modal-header">
          <h2>{t.activityHistory} - {contactName}</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        {!showAddForm ? (
          <div>
            <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0 }}>{t.activities}</h3>
              <button className="btn btn-primary" onClick={() => setShowAddForm(true)}>
                ➕ {t.addActivity}
              </button>
            </div>
            
            {loading ? (
              <p>{t.loading}</p>
            ) : activities.length === 0 ? (
              <div className="empty-state">
                <p>{t.noActivities}</p>
              </div>
            ) : (
              <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                {activities.map((activity) => (
                  <div key={activity.id} style={{
                    padding: '15px',
                    marginBottom: '10px',
                    background: '#faf5f0',
                    borderRadius: '8px',
                    borderLeft: '4px solid #ffd4a3'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                      <span style={{ fontSize: '1.5rem' }}>{getActivityIcon(activity.activity_type)}</span>
                      <div style={{ flex: 1 }}>
                        <strong>{activity.title || t[activity.activity_type] || activity.activity_type}</strong>
                        <p style={{ margin: '4px 0 0 0', fontSize: '0.9rem', opacity: 0.7 }}>
                          {new Date(activity.created_at).toLocaleString(language === 'ar' ? 'ar-SA' : 'en-US')}
                        </p>
                      </div>
                    </div>
                    {activity.description && (
                      <p style={{ margin: '8px 0 0 0', color: '#000000' }}>{activity.description}</p>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>{t.activityType}</label>
              <select
                name="activity_type"
                value={formData.activity_type}
                onChange={(e) => setFormData({ ...formData, activity_type: e.target.value })}
              >
                <option value="call">{t.call}</option>
                <option value="whatsapp">{t.whatsapp}</option>
                <option value="email">{t.email}</option>
                <option value="meeting">{t.meeting}</option>
                <option value="note">{t.note}</option>
              </select>
            </div>
            <div className="form-group">
              <label>{t.title}</label>
              <input
                type="text"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                placeholder={t.titlePlaceholder}
              />
            </div>
            <div className="form-group">
              <label>{t.description}</label>
              <textarea
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                rows="4"
                placeholder={t.descriptionPlaceholder}
              />
            </div>
            <div className="form-actions">
              <button type="button" className="btn btn-secondary" onClick={() => setShowAddForm(false)}>
                {t.cancel}
              </button>
              <button type="submit" className="btn btn-primary">
                {t.save}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ActivityModal;

